module.exports = __webpack_public_path__ + "static/media/HeroBrownie.a89d1d62.jpg";